import {
    elSetCSS,
} from '../utils/element-helpers';

/**
 * Collage
 * 1.0.0
 * 
 * Gets svg item's position, size and z-index to apply css vars to each collage item
 */
const collage = () => {
    const $collages = document.querySelectorAll('[data-collage]');

    $collages.forEach($collage => {
        const $svgs = $collage.querySelectorAll('[data-collage-config]');

        $svgs.forEach($svg => {
            const { type, z = [] } = JSON.parse($svg.getAttribute('data-collage-config'));
            const [ w, h ] = $svg.getAttribute('viewBox').replace('0 0 ', '').split(' ');
            const $rects = $svg.querySelectorAll('rect');

            $rects.forEach(($rect, index) => {
                const iw = parseFloat($rect.getAttribute('width'));
                const ih = parseFloat($rect.getAttribute('height'));
                const ix = parseFloat($rect.getAttribute('x') ?? 0);
                const iy = parseFloat($rect.getAttribute('y') ?? 0);

                const $item = $collage.querySelector(`[data-collage-item]:nth-child(${index + 1})`);

                elSetCSS($item, {
                    [`--${type}-w`]: `${iw/w * 100}%`,
                    [`--${type}-r`]: iw/ih,
                    [`--${type}-x`]: `${ix/w * 100}%`,
                    [`--${type}-y`]: `${iy/h * 100}%`,
                    [`--${type}-z`]: z[index] ?? 1,
                });
            });

            $svg.remove();
        });
    });
}

document.addEventListener('DOMContentLoaded', collage);

export default collage;
